/*eslint-disable */
var $ = window.jQuery = require('jquery');

import 'vue-datetime/dist/vue-datetime.css'

import { Datetime } from 'vue-datetime';
import Multiselect from 'vue-multiselect'
import allCountries from '@/services/phoneCodeList.json';
import blurbContentFLbilConsult from '@/components/public/blurb-content-for-lbil-consult-popup';
import {
  bus
} from '@/main';
import {
  mapGetters
} from 'vuex';
import moment from 'moment';
import toast from '@/services/toast';

// You need a specific loader for CSS files
export default {
  name: 'lbil-teleconsulting-form-poup',
  components: {
    Multiselect,
    datetime: Datetime,
    'blurb-popup-lbil-consult' : blurbContentFLbilConsult
  },
  props: ['scheduleInfo'],
  data () {
    return {
      submitted:false,
      availableDayLabel:[
        {name:'Monday', code:'Monday'},
        {name:'Tuesday', code:'Tuesday'},
        {name:'Wednesday', code:'Wednesday'},
        {name:'Thursday', code:'Thursday'},
        {name:'Friday', code:'Friday'},
        {name:'Saturday', code:'Saturday'},
        {name:'Sunday', code:'Sunday'}
      ],
      languageProficiencyLabel:[
        {name:'English', code:'English'},
        {name:'French', code:'French'},
        {name:'Hindi', code:'Hindi'},
        {name:'Mandarin', code:'Mandarin'},
        {name:'German', code:'German'},
        {name:'Japanese', code:'Japanese'},
        {name:'Korean', code:'Korean'},
        {name:'Italian', code:'Italian'},
        {name:'Cantonese', code:'Cantonese'},
        {name:'Spanish', code:'Spanish'},
        {name:'Bengali', code:'Bengali'},
        {name:'Tamil', code:'Tamil'},
        {name:'Gujrati', code:'Gujrati'},
        {name:'Marathi', code:'Marathi'},
        {name:'Telegu', code:'Telegu'},
        {name:'Malayalam', code:'Malayalam'},
        {name:'Punjabi', code:'Punjabi'},
        {name:'Thai', code:'Thai'},
        {name:'Hebrew', code:'Hebrew'},
        {name:'Arabic', code:'Arabic'},
        {name:'Swahili', code:'Swahili'},
        {name:'Amharic', code:'Amharic'},
        {name:'Russian', code:'Russian'},
        {name:'Bahasa', code:'Bahasa'},
        {name:'Malay', code:'Malay'},
        {name:'Portugese', code:'Portugese'},
      ],
      availableDayValue:[],
      availableDaySelectedArrValue:[],
      languageProficiencyValue:[],
      sendLanguageProficiencyValue:[],
      start_time:'',
      end_time:'',
      timeDiffValidation:false,
      allCountriesList:[],
      license:{
        number: '',
        isValid: false,
        countryIso: '',
        countryCode:''
      },
      registrationPortal:'',
      uploadLicenseFile:null,
      uploadLicenseFileName:'',
      onlineTeleconsulting:false,
      user_agreement:false,
      disabledSomeFields:false,
      consultFees:'',
      currencyListLabel:[
        'USD',
        'EUR',
        'GBP'
      ],
      currencyVal:'',
      about_doctor:'',
      blurOfLbilConsultPopupState:true
    }
  },
  computed: {
    ...mapGetters([
      'acUserDetailsStateGetters'
    ]),
    getSelfUserInfoMethod(){
      this.selfUserInfoData = this.$store.getters.acUserDetailsStateGetters.data
      return
    },
  },
  mounted(){
    for (var i = 0; i < allCountries.length; i++) {
      let c = allCountries[i];
      this.allCountriesList.push({
        name: c[0],
        iso2: c[1],
        dialCode: c[2],
        priority: c[3] || 0,
        areaCodes: c[4] || null
      });
    }
    this.getSelfUserInfoMethod
    if(this.scheduleInfo){
      if(this.scheduleInfo.doctor_schedule){
        if(this.scheduleInfo.license_file){
          this.uploadLicenseFileName = this.scheduleInfo.license_file.split("/")[5].split("?")[0]
        }
        this.about_doctor = this.scheduleInfo.doctor_schedule.about_doctor
        this.user_agreement = this.scheduleInfo.doctor_schedule.read_terms_1
        this.onlineTeleconsulting = this.scheduleInfo.doctor_schedule.read_terms_2
        this.consultFees = this.scheduleInfo.doctor_schedule.amount
        this.currencyVal = this.scheduleInfo.doctor_schedule.currency
        this.disabledSomeFields = this.scheduleInfo.doctor_schedule.read_terms_2
        this.license.number = this.scheduleInfo.doctor_schedule.license_value || ''
        this.license.countryCode = this.scheduleInfo.doctor_schedule.license_country_code || ''
        if(this.license.countryCode != null && this.license.countryCode != ''){
          this.license.countryIso = this.allCountriesList.filter(item => item.dialCode == this.license.countryCode)[0].iso2;
        }
        this.registrationPortal = this.scheduleInfo.doctor_schedule.license_portal || ''
        if(this.scheduleInfo.doctor_schedule.available_of_day && this.scheduleInfo.doctor_schedule.available_of_day.length > 0){
          for(var i = 0; i < this.scheduleInfo.doctor_schedule.available_of_day.length; i++){
            this.availableDayValue.push({name:this.scheduleInfo.doctor_schedule.available_of_day[i],code:this.scheduleInfo.doctor_schedule.available_of_day[i]})
          }
        }
        if(this.scheduleInfo.doctor_schedule.language && this.scheduleInfo.doctor_schedule.language.length > 0){
          for(var i = 0; i < this.scheduleInfo.doctor_schedule.language.length; i++){
            this.languageProficiencyValue.push({name:this.scheduleInfo.doctor_schedule.language[i],code:this.scheduleInfo.doctor_schedule.language[i]})
          }
        }
        this.start_time = this.scheduleInfo.doctor_schedule.available_of_start_time
        this.end_time = this.scheduleInfo.doctor_schedule.available_of_end_time
      }else{
        if(this.scheduleInfo.license_file){
          this.uploadLicenseFileName = this.scheduleInfo.license_file.split("/")[5].split("?")[0]
        }
        this.license.number = this.scheduleInfo.license_value || ''
        this.license.countryCode = this.scheduleInfo.license_country_code || ''
        this.registrationPortal = this.scheduleInfo.license_portal || ''
      }
    }
    this.getUserCountry();
    $('.license_for_list').click(function(e) {
      e.preventDefault();
      $(this).toggleClass('open');
      $(this).find('ul').slideToggle(100);
      if ($(this).hasClass('open')) {
        $('.dropdown-arrow').text('▼');
      } else {
        $('.dropdown-arrow').text('▲');
      }
    });
    $(document).on('click', function(e) {
      var container = $('.license_for_list');
      // if the target of the click isn't the container nor a descendant of the container
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        container.removeClass('open');
        $('.dropdown-arrow').text('▲');
        container.find('ul').slideUp(100);
      }
    })
    bus.$on('blurOfLbilConsultPopupStateBus', (data) => {
      this.blurOfLbilConsultPopupState = data
    })
  },
  methods: {
    getUserCountry() {
      var self = this;
      fetch('https://ip2c.org/s')
        .then(function(response) {
          return response.text();
        })
        .then(function(text) {
          if (!text || "1" !== text[0])
            throw new Error("unable to fetch the country");
            self.license.countryIso = (text.substr(2, 2)).toLowerCase();
            self.license.countryCode = self.allCountriesList.filter(item => item.iso2 == self.license.countryIso)[0].dialCode;
        })
        .catch(function(error) {
          console.log('Request failed', error)
        });
    },
    handleUploadLicenseFile(event) {
      if(event.target.files && event.target.files.length > 0) {
        this.uploadLicenseFile = event.target.files[0];
        this.uploadLicenseFileName = this.uploadLicenseFile.name
      }else {
        this.uploadLicenseFileName = '';
      }
    },
    chooseCountryForLicense(country) { 
      this.license.countryIso = country.iso2;
      this.license.countryCode = country.dialCode
    },
    getTimeDiffBtWStartandEndMethod(nowt, thent){
      var now  = moment(nowt).format('HH:mm:ss');
      var then = moment(thent).format('HH:mm:ss');
      var outputs = moment.utc(moment(then,"HH:mm:ss").diff(moment(now,"HH:mm:ss"))).format("HH:mm:ss")
      if(outputs > '03:59:59'){
        this.timeDiffValidation = false;
        return true;
      }else{
        this.timeDiffValidation = true;
        return false;
      }
    },
    addTagOfLanguageProficiency (newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
      }
      this.languageProficiencyValue.push(tag)
    },
    updateAboutBeforeSubmitMethod(){
      if(this.getTimeDiffBtWStartandEndMethod(this.start_time, this.end_time) == false){
        return;
      }
      this.$validator.validateAll().then((result) => {
        if(result){
          this.submitted =  true
          for(var i = 0; i < this.availableDayValue.length; i++){
            this.availableDaySelectedArrValue.push(this.availableDayValue[i].name)
          }
          for(var i = 0; i < this.languageProficiencyValue.length; i++){
            this.sendLanguageProficiencyValue.push(this.languageProficiencyValue[i].name)
          }
           let doctorAvaibleData = {
              available_of_day:JSON.stringify(this.availableDaySelectedArrValue),
              available_of_start_time:this.start_time,
              available_of_end_time:this.end_time,
              language:JSON.stringify(this.sendLanguageProficiencyValue),
              read_terms_1:this.user_agreement,
              read_terms_2:this.onlineTeleconsulting,
              amount:this.consultFees,
              currency:this.currencyVal,
              about_doctor:this.about_doctor
            }
            if(this.registrationPortal != ''){
              doctorAvaibleData.license_portal = this.registrationPortal;
            }
            if(this.license.number != ''){
              doctorAvaibleData.license_value = this.license.number;
              doctorAvaibleData.license_country_code = this.license.countryCode;
            }
           
          this.$store.dispatch('doctorAvaibleDayTimeForConsultMethod', doctorAvaibleData)
            .then((res) => {  
              if(this.uploadLicenseFile){
                let formData = new FormData();
                formData.append('license_file', this.uploadLicenseFile);
                this.$store.dispatch('uploadLicenseFileOfDoctorMethod', formData)
              }
              toast.success(res.data.msg);
              this.submitted =  false
              this.getAboutDetailForUserInfoMethod()
              this.closeUpdateAboutUserInfoPopup()
            }).catch((err) => {
              toast.error( err.data.user_msg || err.data.msg);
              this.submitted =  false
            })
          return;
        }
      })
    },
    closeUpdateAboutUserInfoPopup(){
      $('body').removeClass('body_right_scroll_remove')
      bus.$emit('lbilTeleconsultingStateBus', false);
    },
    getAboutDetailForUserInfoMethod(){
    this.$store.dispatch('getAcUserDetailsFun')
    }
  },
  watch: {
    getSelfUserInfoMethod(){
      return this.$store.getters.acUserDetailsStateGetters
    },
  },
}